import { render, staticRenderFns } from "./PageMainMaintenance.vue?vue&type=template&id=33b9e9f3&scoped=true&"
import script from "./PageMainMaintenance.vue?vue&type=script&lang=js&"
export * from "./PageMainMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./PageMainMaintenance.vue?vue&type=style&index=0&id=33b9e9f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9e9f3",
  null
  
)

export default component.exports